<template>
	<div>
		<div class="topbar">
			<div>
				<el-input v-model="searchKeyword" placeholder="用户工作单位/工作地点省份/工作地点城市/工作地点县区/科室/身份证号码/人物介绍/姓名/昵称"
					size="small" prefix-icon="el-icon-search" class="search-input" @keyup.enter.native="search()" />
				<el-button type="primary" icon="el-icon-search" size="small" :disabled="!searchKeyword"
					@click.stop="search()">
					搜索
				</el-button>


				<el-select clearable v-model="curAuditOption" style="padding-left:20px;" @change="onAuditOptionChange">
					<el-option v-for="item in auditStatusOptions" :value="item" :label="item|auditStatusTransform"
						:key="item" />
				</el-select>

				<el-select clearable v-model="curRoleOption" style="padding-left:20px" @change="onRoleOptionChange">
					<el-option v-for="item in roleOptions" :value="item" :label="item|consultationRoleTransform"
						:key="item" />
				</el-select>

			</div>
			<el-button type="primary" size="small" @click="addExpertDlg = true">添加会诊专家</el-button>
		</div>
		<el-table ref="tableRef" v-loading="loading" :header-cell-style="{ background: '#F5F7FA' }"
			style="width: 100%; margin-bottom: 20px" border :data="consultationApplyList" accordion
			highlight-current-row @expand-change="expandChange" :row-key="getRowKey" :expand-row-keys="expandedRow">
			<!-- @row-click="rowClick" -->
			<el-table-column type="expand">
				<template #default="props">
					<req-info-view :entity="props.row" />

				</template>
			</el-table-column>
			<!-- ID -->
			<el-table-column align="center" prop="createUserID" label="ID" />
			<!-- 头像 -->
			<el-table-column align="center" label="头像">
				<template #default="scope">
					<el-avatar key="avatar" :size="40" acc :src="config.RESOURCES+scope.row.avatar" />
				</template>
			</el-table-column>
			<!-- 姓名 -->
			<el-table-column align="center" label="姓名">
				<template #default="scope" style="display: flex; align-items: center">
					{{ scope.row.firstName }}{{scope.row.lastName}}
				</template>
			</el-table-column>
			<!-- 身份证 -->
			<el-table-column align="center" prop="idNumber" label="身份证" />
			<!-- 科室 -->
			<el-table-column align="center" prop="subject" label="科室" />
			<!-- 公司 -->
			<el-table-column align="center" prop="company" label="公司" />
			<!-- 认证类型 -->
			<el-table-column align="center" label="认证类型" fil>
				<template #default='scope'>
					<el-tag :type="scope.row.role === 0 ? 'success' : ''">{{scope.row.role | consultationRoleTransform}}
					</el-tag>
				</template>

			</el-table-column>
			<!-- 申请时间 -->
			<el-table-column align="center" label="申请时间">
				<template #default='scope'>
					{{scope.row.createTime | formatDateTime}}
				</template>
			</el-table-column>
			<!-- 审核状态 -->
			<el-table-column align="center" prop="" label="审核状态">
				<template #default="scope" style="display: flex; align-items: center">

					<el-tooltip v-if="scope.row.auditStatus === 2" effect="dark" :content="'驳回原因：'+scope.row.reason">
						<el-tag
							:type="scope.row.auditStatus == 0 ? 'info' : scope.row.auditStatus == 1 ? 'success' : 'danger'">
							{{ scope.row.auditStatus | auditStatusTransform}}
						</el-tag>
					</el-tooltip>
					<el-tag v-else
						:type="scope.row.auditStatus == 0 ? 'info' : scope.row.auditStatus == 1 ? 'success' : 'danger'">
						{{ scope.row.auditStatus | auditStatusTransform}}
					</el-tag>

				</template>
			</el-table-column>
			<!-- 操作 -->
			<el-table-column align="center" prop="operation" label="操作:通过/驳回" width="250">
				<template slot-scope="scope">
					<el-button type="primary" size="small" @click.stop="showDetailDlg(scope.row)">详情
					</el-button>
					<el-button type="success" size="small" :disabled="scope.row.auditStatus !== 0"
						@click.stop="acceptConsultationUserReq(scope.row)">通过</el-button>
					<el-button type="warning" size="small" :disabled="scope.row.auditStatus !== 0"
						@click.stop="rejectConsultationUserReq(scope.row)">驳回
					</el-button>
				</template>
			</el-table-column>


		</el-table>
		<el-pagination background :hide-on-single-page="true" :total="totalCount" :page-size="pageSize"
			:current-page="currentPage" @current-change="currentChange" />

		<!-- 添加专家 -->
		<search-user-dlg :visiable="addExpertDlg" dlgTitle="添加会诊专家" @dlg-close="addExpertDlg = false">
			<template #default="scope">
				<el-button size="small" type="primary" @click="setExpert(scope.entity)">
					设为会诊专家
				</el-button>
			</template>
		</search-user-dlg>

		<el-dialog :key="detailInfo.consultationUserReqID" v-if="showDetailInfo" :visible.sync="showDetailInfo" destroy-on-close title="申请详情">
			<req-detail-view :entity="detailInfo" @on-accept="onAcceptConsultationUserReq(detailInfo)"
				@on-reject="onRejectConsultationUserReq(detailInfo)" />
		</el-dialog>
	</div>

</template>

<script>
	import {
		getAllRoleApplication,
		updateRoleApplication,
	} from "@/api/system/diagnosisManagement/diagnosticRoleApplication"
	import {
		isVaild
	} from "@/utils/validate"
	import searchUserDlg from "@/components/searchUserDlg/searchUserDlg"
	import reqInfoView from "@/views/systemManagement/userManagement/UserAuthentication/consultationUserReqInfoView"
	import reqDetailView from "@/views/systemManagement/diagnosisManagement/roleApplicationMgt/detail/index"
	import {
		printObj
	} from "@/utils/debug"
	export default {
		components: {
			searchUserDlg,
			reqInfoView,
			reqDetailView
		},
		data() {
			return {
				loading: false,
				totalCount: 0, // 列表总数
				pageSize: 10, // 单页条数
				currentPage: 1, // 当前页码
				searchKeyword: "", //搜索关键词
				consultationApplyList: [],
				auditStatusOptions: [
					0, 1, 2
				],
				curAuditOption: "",
				roleOptions: [
					0, 1
				],
				curRoleOption: "",
				expandedRow: [],
				//添加会诊专家相关
				addExpertDlg: false,
				//会诊详情对话框
				showDetailInfo: false,
				detailInfo: {}
			}
		},
		created() {
			this.getConsulationApplyList();
		},
		methods: {
			search() {
				this.regetlistData();
			},

			/**
			 * 获取会诊用户申请列表
			 */
			async getConsulationApplyList() {
				this.loading = true;
				let where = []
				console.log('where curAuditOptions ' + this.curAuditOptions + " curRoleOption " + this.curRoleOption)
				if (isVaild(this.curAuditOption)) {
					where.push({
						"field": "auditStatus",
						"value": this.curAuditOption,
						"op": "equal"
					})
				}
				if (isVaild(this.curRoleOption)) {
					where.push({
						"field": "role",
						"value": this.curRoleOption,
						"op": "equal"
					})
				}
				let param = {
					keyWord: this.searchKeyword,
					pageIndex: this.currentPage,
					pageSize: this.pageSize,
				}
				console.log('where length ' + where.length)
				if (where.length > 0) {
					param.where = where
				}
				let resp = await getAllRoleApplication(param)
				this.consultationApplyList = resp.data.list
				this.totalCount = resp.data.total
				this.utils.stopLoading(this);
			},

			/**
			 * 分页
			 * @param {Object} currentPage
			 */
			currentChange(currentPage) {
				this.currentPage = currentPage
				this.getConsulationApplyList()
			},

			/**
			 * 审核申请
			 * @param {Object} status
			 */
			consultationUserReqAudit(consultationUserReqID, auditStatus, reason) {
				const param = {
					auditStatus: auditStatus,
					consultationUserReqID: consultationUserReqID,
					reason: reason,
				};
				updateRoleApplication(param).then((res) => {
					if (res.code === 200) {
						this.$message({
							message: "操作成功",
							type: "success",
						});
					} else {
						this.$message({
							message: res.message,
							type: "warning",
						});
						return;
					}
					this.$store.dispatch("newMsg/setConsultationAuthenticationNo")
					this.getConsulationApplyList();
				})
			},

			/**
			 * 通过审核
			 * @param {Object} row
			 */
			acceptConsultationUserReq(row) {
				this.consultationUserReqAudit(row.consultationUserReqID, 1)
			},
			/**
			 * 驳回
			 * @param {Object} row
			 */
			async rejectConsultationUserReq(row) {
				this.$prompt("请输入驳回原因").then(({
					value
				}) => {
					this.consultationUserReqAudit(row.consultationUserReqID, 2, value)
				})

			},
			/**
			 * 详情对话框点击通过
			 * @param {Object} row
			 */
			onAcceptConsultationUserReq(row) {
				console.log('')
				this.acceptConsultationUserReq(row)
				this.showDetailInfo = false
			},
			/**
			 * 详情对话框点击通过
			 * @param {Object} row
			 */
			async onRejectConsultationUserReq(row) {

				await this.rejectConsultationUserReq(row)
				this.showDetailInfo = false
			},
			/**
			 * 筛选条件审核状态改变回调
			 */
			onAuditOptionChange() {
				console.log('onAuditOptionChange ' + this.curAuditOption)
				this.regetlistData();
			},
			/**
			 * 筛选条件角色改变回调
			 */
			onRoleOptionChange() {
				this.regetlistData()
			},
			/**
			 * 重新获取数据
			 */
			regetlistData() {
				this.currentPage = 1
				this.getConsulationApplyList()
			},
			/**
			 * @param {Object} row
			 */
			toggleExpanded(row) {
				this.$refs.tableRef.toggleRowExpansion(row)
			},
			/**
			 * 返回table的row key
			 * @param {Object} row
			 */
			getRowKey(row) {
				return row.consultationUserReqID
			},
			/**
			 * table的展开改变回调
			 * @param {Object} row
			 * @param {Object} expandedRows
			 */
			expandChange(row, expandedRows) {
				if (this.expandedRow.indexOf(row.consultationUserReqID) >= 0) {
					this.expandedRow = []
				} else {
					this.expandedRow = [row.consultationUserReqID]
				}

			},

			rowClick(row) {
				this.$refs.tableRef.toggleRowExpansion(row)
			},

			go2Detail(entity) {
				this.$router.push({
					name: "diagnosticUserDetail",
					params: {
						userDetail: entity,
					},
				});
			},

			/**
			 * 设为会诊专家
			 * @param {Object} entity
			 */
			setExpert(entity) {
				console.log("set expert")
			},

			showDetailDlg(entity) {
				this.detailInfo = entity
				this.showDetailInfo = true;

			}
		}
	}
</script>

<style>
	.pic {
		width: 250px;
		height: 140px;
	}

	.row {
		margin: 20px;
	}

	.bold {
		font-weight: bold
	}

	.el-table__expanded-cell,
	.el-table__expanded-cell:hover {
		background-color: #F5F7FA !important;
	}
</style>
